import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import { AssetTypes } from "@zapier/utils";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

export function useEmitAssetRowInteractionEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (assetType: AssetTypes, assetId: string | number) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.AssetRowInteraction,
        optionSelected: assetType,
        customTrackingFields: {
          asset_id: assetId,
        },
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
